import {
  CrmLayoutCollapseComponent,
  CrmLayoutLogoComponent,
  CrmLayoutMenuComponent,
  crmLayoutSidebarOnly,
  CrmLayoutV2Config,
} from '@touch4it/ng-swp/layout-v2';

import { adminRoles, allLoggedInRoles } from '~/shared/types/user.role';

import { LogoutComponent } from '../layout/logout.component';
import { MenuProvider } from '../layout/menu.provider';

export const layoutConfig: CrmLayoutV2Config = {
  ...crmLayoutSidebarOnly,
  siderLeft: {
    ...crmLayoutSidebarOnly.siderLeft,
    fragments: [
      { key: 'logo', content: CrmLayoutLogoComponent },
      { key: 'menu', content: CrmLayoutMenuComponent, provider: MenuProvider },
      { key: 'collapse', content: CrmLayoutCollapseComponent },
      { key: 'logout', content: LogoutComponent },
    ],
  },
  menu: {
    prefix: 'app',
    items: [
      {
        key: 'home.title',
        icon: 'dashboard',
        routeKey: 'home',
      },
      {
        key: 'erp.title',
        icon: 'appstore',
        routeKey: 'erp',
        role: allLoggedInRoles,
        children: [
          {
            key: 'supplements.title',
            icon: 'build',
            routeKey: 'supplements',
          },
          {
            key: 'packagings.title',
            icon: 'gift',
            routeKey: 'packagings',
          },
          {
            key: 'products.title',
            icon: 'shopping-cart',
            routeKey: 'products',
          },
          {
            key: 'claims.title',
            icon: 'exception',
            routeKey: 'claims',
          },
        ],
      },
      {
        key: 'users.title',
        icon: 'team',
        routeKey: 'users',
        role: adminRoles,
      },
      {
        key: 'settings.title',
        icon: 'setting',
        routeKey: 'settings',
        role: adminRoles,
      },
    ],
  },
  content: {
    footer: {
      fragments: [
        // TODO: version component
      ],
    },
  },
};
